import { render } from "./hanghaiBill.vue?vue&type=template&id=5e2c5ada&scoped=true"
import script from "./hanghaiBill.vue?vue&type=script&lang=js"
export * from "./hanghaiBill.vue?vue&type=script&lang=js"

import "./hanghaiBill.vue?vue&type=style&index=0&id=5e2c5ada&scoped=true&lang=css"
import "./hanghaiBill.vue?vue&type=style&index=1&id=5e2c5ada&lang=css"
script.render = render
script.__scopeId = "data-v-5e2c5ada"

export default script